import { useField } from 'react-final-form';
export const useIsValidSection = sectionName => {
  const {
    meta: {
      error,
      submitError,
      dirtySinceLastSubmit
    }
  } = useField(sectionName);

  // `false` makes sure flow infers "boolean" instead of "any|boolean"
  return !error && !submitError || dirtySinceLastSubmit || false;
};